import { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

const cardsData = [
  {
    id: 1,
    label: "Real Outcomes",
    image: "/images/tab-slider/1.avif",
    para_one:
      "Focus on real measurable outcomes and provides weekly updates with monthly reviews.",
    para_two: "App = entire relationship",
  },
  {
    id: 2,
    label: "Analytical",
    image: "/images/tab-slider/2.avif",
    para_one: "Every recommendation is backed by analysis, not random tips.",
    para_two: "Tips on WhatsApp",
  },
  {
    id: 3,
    label: "Accountability",
    image: "/images/tab-slider/3.avif",
    para_one:
      "Complete strategy ownership — ensuring you always know what’s happening and why.",
    para_two: "No accountability",
  },
  {
    id: 4,
    label: "Strategical",
    image: "/images/tab-slider/4.avif",
    para_one:
      "Offers expert-curated, research-driven strategies tailored specifically to your financial goals.",
    para_two: "Same strategy for all",
  },
];

const HowGateway = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);

  const handleButtonClick = (index) => {
    setActiveIndex(index);
    if (swiperRef.current) {
      swiperRef.current.slideToLoop(index);
    }
  };

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  return (
    <section id="tab-section">
      <div className="container">
        <div className="row mb-2">
          <div className="col-lg-12 text-center">
            <h3 data-aos="fade-up">
              How is Gateway different from <br /> Direct Access and Discount
              brokers?
            </h3>
          </div>
        </div>

        <div
          className="row mb-4 d-flex justify-content-center btn-row"
          role="tablist"
        >
          {cardsData.map((card, index) => {
            const isActive = activeIndex === index;
            return (
              <button
                key={card.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                className={isActive ? "active" : ""}
                onClick={() => handleButtonClick(index)}
              >
                {card.label}
              </button>
            );
          })}
        </div>

        <div className="row">
          <div className="col-lg-12">
            <Swiper
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
              loop={true}
              spaceBetween={35}
              slidesPerView={1}
              speed={500}
              className="tab-slider"
            >
              {cardsData.map((card) => (
                <SwiperSlide key={card.id}>
                  <div className="item tab-slide">
                    <div className="tab-slide-img">
                      <img src={card.image} alt={card.label} loading="lazy" />
                      <div className="layer">
                        <img src="/images/tab-slider/layer.avif" alt="" />
                      </div>
                    </div>
                    <div className="tab-slide-content">
                      <h4>Gateway Financial Services Limited</h4>
                      <div className="d-flex align-items-start">
                        <i
                          className="fa fa-check-circle text-success mr-2 mt-1"
                          aria-hidden="true"
                        />
                        <p>{card.para_one}</p>
                      </div>
                      <h4>Direct Access and Discount brokers:</h4>
                      <div className="d-flex align-items-start">
                        <i
                          className="fa fa-times-circle text-danger mr-2 mt-1"
                          aria-hidden="true"
                        />
                        <p>{card.para_two}</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="slider-navigation">
              <button
                type="button"
                id="tab-prev"
                onClick={handlePrev}
                aria-label="Previous slide"
              >
                <img
                  src="/images/tab-slider/arrow.png"
                  alt=""
                  style={{ rotate: "180deg" }}
                />
              </button>
              <button
                type="button"
                id="tab-next"
                onClick={handleNext}
                aria-label="Next slide"
              >
                <img src="/images/tab-slider/arrow.png" alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <img
        src="/images/tab-slider/wave-1.avif"
        alt=""
        loading="lazy"
        className="wave-1 wave"
      />
      <img
        src="/images/tab-slider/wave-2.avif"
        alt=""
        loading="lazy"
        className="wave-2 wave"
      />
    </section>
  );
};

export default HowGateway;
